import { type IconProps } from './types'

export function FacebookIcon({ width = '24', height = '24' }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 26.9874 6.5856 34.4358 15.1875 35.7813V23.2031H10.6172V18H15.1875V14.0344C15.1875 9.52313 17.8744 7.03125 21.9858 7.03125C23.9554 7.03125 26.0156 7.38281 26.0156 7.38281V11.8125H23.7459C21.5099 11.8125 20.8125 13.2002 20.8125 14.625V18H25.8047L25.0066 23.2031H20.8125V35.7813C29.4144 34.4358 36 26.9874 36 18Z"
        fill="#1877F2"
      />
    </svg>
  )
}
